import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { BACKEND_URL } from '../config';

// Компонент для відображення завантаження (можна зробити красивішим)
const LoadingIndicator = () => <div style={{ padding: '20px', textAlign: 'center' }}>Перевірка автентифікації...</div>;

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const [isAuthenticated, setIsAuthenticated] = useState(null); // null - невідомо, true - так, false - ні
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const validateToken = async () => {
            const token = localStorage.getItem('authToken');
            if (!token) {
                setIsAuthenticated(false);
                setLoading(false);
                return;
            }

            try {
                // Вказуємо ПОВНУ URL бекенду
                const response = await fetch(`${BACKEND_URL}/api/auth/validate`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        // 'Content-Type': 'application/json' // Не потрібний для GET
                    }
                });

                if (response.ok) {
                    // Токен валідний
                    setIsAuthenticated(true);
                } else {
                    // Токен невалідний (прострочений, неправильний підпис і т.д.)
                    localStorage.removeItem('authToken'); // Видаляємо невалідний токен
                    setIsAuthenticated(false);
                }
            } catch (error) {
                console.error('Помилка валідації токену:', error);
                localStorage.removeItem('authToken'); // Видаляємо токен при помилці мережі/сервера
                setIsAuthenticated(false);
            } finally {
                setLoading(false);
            }
        };

        validateToken();
    }, []); // Запускаємо перевірку лише один раз при монтуванні

    if (loading) {
        // Поки йде перевірка, показуємо індикатор завантаження
        return <LoadingIndicator />;
    }

    if (isAuthenticated === false) {
        // Якщо перевірка завершилась і користувач не автентифікований
        return <Navigate to="/room-for-big-guys-qmttydsra-53231998/login" state={{ from: location }} replace />;
    }

    if (isAuthenticated === true) {
        // Якщо перевірка завершилась і користувач автентифікований
        return children;
    }

    // На випадок, якщо щось пішло не так (хоча стан повинен бути true/false після завантаження)
    return <Navigate to="/room-for-big-guys-qmttydsra-53231998/login" state={{ from: location }} replace />;
};

export default ProtectedRoute; 